import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
var Cambio_destinoComponent = /** @class */ (function () {
    function Cambio_destinoComponent(_formService) {
        this._formService = _formService;
        this.rows = [];
        this.matcher = new FormService();
        this.form = new FormGroup({
            cambio_destino: new FormControl(''),
        });
        if (!JSON.parse(localStorage.getItem("cambio_destino"))) {
            localStorage.setItem("cambio_destino", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("cambio_destino"));
            this.form.controls['cambio_destino'].setValue(this.rows[0] ? this.rows[0].cambio_destino : '');
        }
    }
    Cambio_destinoComponent.prototype.add_cambio_destino = function () {
        localStorage.setItem("cambio_destino", JSON.stringify([]));
        this.actualRow = localStorage.getItem("cambio_destino");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            cambio_destino: this.form.value.cambio_destino,
        });
        localStorage.setItem("cambio_destino", JSON.stringify(this.rows));
        //this.form.reset();
        //this.cip = JSON.parse(localStorage.getItem("cip"));
    };
    Cambio_destinoComponent.prototype.delete_cambio_destino = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("cambio_destino", JSON.stringify(this.rows));
            }
        }
    };
    return Cambio_destinoComponent;
}());
export { Cambio_destinoComponent };
